import React, { FC, useCallback, useState, MouseEvent } from 'react'

import HorizontalAssetsPreview from '../HorizontalAssetsPreview'
import styles from './AssetPreviewModal.module.scss'
import AssetPreviewModalHeader from './AssetPreviewModalHeader'

import Previewer from '~elements/Previewer/Previewer'
import { AssetFile } from '~generated/types'
import Modal from '~lib/ui-kit/Modal'

interface AssetPreviewModalProps {
  files: AssetFile[]
  initialFileIndex: number
  onClose: VoidFunction
  onDownload: (url: string, name: string) => void
}

const AssetPreviewModal: FC<React.PropsWithChildren<AssetPreviewModalProps>> = ({
  files,
  onClose,
  initialFileIndex,
  onDownload,
}) => {
  const [currentAsset, setCurrentAsset] = useState<AssetFile>(files[initialFileIndex])

  const handleDownload = useCallback(() => {
    const { url, name } = currentAsset

    onDownload(url, name)
  }, [currentAsset, onDownload])

  const handleSlideChange = useCallback(
    (_: number, next: number) => {
      setCurrentAsset(files[next])
    },
    [files]
  )

  const handleClose = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation()
      e.preventDefault()
      onClose()
    },
    [onClose]
  )

  return (
    <Modal overlayVariant="blur" opened onOverlayClick={handleClose} onClose={handleClose} onEscapePress={onClose}>
      <div className={styles.root}>
        <AssetPreviewModalHeader name={currentAsset?.name} onDownload={handleDownload} />
        <HorizontalAssetsPreview
          fullWidth
          initialSlide={initialFileIndex}
          beforeChange={handleSlideChange}
          controlsClassName={styles.controls}
        >
          {files.map(({ url, format }) => (
            <Previewer key={url} format={format} url={url} />
          ))}
        </HorizontalAssetsPreview>
      </div>
    </Modal>
  )
}

export default AssetPreviewModal
